import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { combineReducers } from 'redux'

let defaultState = {
  deleteLessonDialogId: null,
  createModalOpen: false,
  shareModal: false
}

const LessonListReducer = combineReducers({
  shareLessonRequest: createRequestReducer('LESSON_LIST:SHARE'),
  state: createReducer(defaultState, {
    'LESSON_LIST:SHOW_DELETE_LESSON_DIALOG': (state, { lessonId }) => ({
      ...state,
      deleteLessonDialogId: lessonId
    }),
    'LESSON_LIST:CLOSE_DELETE_LESSON_DIALOG': state => ({
      ...state,
      deleteLessonDialogId: null
    }),
    'OPEN_LESSONS:CREATE_REQUEST_SUCCESS': state => ({
      ...state,
      createModalOpen: false
    }),
    'LESSON_LIST:OPEN_SHARE_MODAL': (state, { id }) => ({
      ...state,
      shareModal: { opened: true, id }
    }),
    'LESSON_LIST:CLOSE_SHARE_MODAL': state => ({
      ...state,
      shareModal: { ...state.shareModal, opened: false }
    }),
    'LESSON_LIST:SHARE_REQUEST_SUCCESS': state => ({
      ...state,
      shareModal: { ...state.shareModal, opened: false }
    })
  })
})

export default LessonListReducer
